import { tokenizer } from './tokenizer';
import { parse } from '../parser/parse';
import { htmlEscape } from '../string/htmlEscape';

/**
 * Devuelve una cadena evaluada como si fuera un template literal.
 * Es equivalente a un template literal y solo sirve cuando no se puede usar directamente.
 *
 * @param {string} str la cadena a evaluar
 * @param {object} scope el contexto donde se tiene que ejecutar la función
 * @param {object} [options] opciones
 * @param {object} [options.escape=true] Si false, no escapa la cadena -> permite insertar html pero solo si confiamos. Por defecto escapa.
 *
 * @example
 * interpolate('eso es ${mi.respuesta}', { mi: { respuesta: 42 } }) // -> "eso es 42"
 */
export function interpolate(str, scope = {}, options = {}) {
  if (typeof str !== 'string') {
    throw new TypeError('La expresión debe ser de tipo string');
  }
  options = Object.assign(
    {
      escape: true,
      referenceError: false,
      typeError: false,
      noUndefined: true,
    },
    options,
    { returnDefault: '' }
  );
  const [strings, expressions] = tokenizer(str);

  const result = strings.reduce((acc, cur, index) => {
    const exp = expressions[index] ? parse(scope, expressions[index], options) : '';
    return acc + cur + exp;
  }, '');

  return options.escape ? htmlEscape(result) : result;
}
